export const matchesSearch = (task, searchQuery, tags = []) => {
  const parts = searchQuery.toLowerCase().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return false;
  const searchable = [
    task.title,
    task.description,
    ...(task.tags || []).map(tagId => {
      const tag = tags.find(t => t.id === tagId);
      return tag ? tag.name : '';
    })
  ]
    .join(' ')
    .toLowerCase();
  return parts.every(part => searchable.includes(part));
};